export default __webpack_public_path__ + "static/pragicts-cloudops-iot-367fe17641fd2e1aaf7e06abc324b3e7.jpg";